import { APP_PATHS } from '../../constants/appPaths';

/**
 * Caminho de uma aba de configurações.
 *
 * Passou a ser URL de verdade (`?tab=<id>`): antes a seção viajava em
 * `location.state`, o que impedia mandar link direto ao usuário e sumia num
 * refresh. Os ids são os de `pages/Settings/constants.js`.
 */
export const getSettingsPathWithTab = (tabId) => `${APP_PATHS.SETTINGS}?tab=${tabId}`;
